import React from 'react';
import cn from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useDispatch } from 'react-redux';
import { feedbackPageReload } from '../redux/actions/app';
import { useTranslation } from 'react-i18next';
import s from './GenericError.scss';
const GenericError = ()=>{
    const { t } = useTranslation('nc');
    const dispatch = useDispatch();
    const doReload = ()=>{
        dispatch(feedbackPageReload({}));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'])
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['header']
    }, t('nc:generic.error.header')), /*#__PURE__*/ React.createElement("p", null, t('nc:generic.error.text')), /*#__PURE__*/ React.createElement(GhostButton, {
        size: 'medium',
        variant: 'main',
        onClick: doReload
    }, t('nc:generic.error.btn.reload')));
};
GenericError.displayName = 'GenericError';
export default GenericError;
